<div *ngIf="!loading" class="container margin-top-1 pb-5">
  <div class="row">
    <!-- Left -->
    <div class="col-md-8 margin-top-1">
      <!-- Photo -->
      <mat-card class="custom-dashboard-mat-card rounded-30">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center">
            <img id="dashboard-photo" [src]="user.profile_photo_path" appErrorImage class="dashboard-image-user"
              (click)="photo.click()" alt="Haz click para añadir una imagen" />
            <input #photo type="file" accept="image/png,image/jpeg" (change)="onSelectFile($event.target)"
              style="display: none" name="photo-profile" id="photo-profile"/>
              <p class="text-center pt-2"><strong>{{user.name}} {{user.surname}}</strong></p>
              <p class="small pt-2 text-secondary"><i class="fas fa-info-circle"></i> {{ "click-change-image" | translate }} </p>
          </div>
        </div>
      </mat-card>

      <mat-card class="custom-dashboard-mat-card margin-top-1">
        <div class="mat-h3 font-weight-bold primary"><i class="fas fa-school"></i> {{ "your-next-class" | translate }}:</div>

        <div *ngIf="!nextClass; else hasClassTemplate">
          <div class="margin-vertical-1 margin-left-1 light-gray">
            {{ "not-next-class" | translate }}
          </div>
        </div>

        <ng-template #hasClassTemplate>
          <div class="margin-left-1">
            <div>
              <span class="mat-h4 gray">{{ "teacher" | translate }}:</span>
              {{ nextClass.teacher_name }}
            </div>
            <div>
              <span class="mat-h4 gray">{{ "subject" | translate }}:</span>
              {{ nextClass.lesson_name }}
            </div>
            <div>
              <span class="mat-h4 gray">{{ "start" | translate }}:</span>
              {{ nextClassStart }}
            </div>
            <div>
              <span class="mat-h4 gray">{{ "end" | translate }}:</span>
              {{ nextClassEnd }}
            </div>
          </div>
          <button *ngIf="nextClassButton" class="margin-top-1 width-100" mat-raised-button color="primary" 
          [routerLink]="nextClass.is_group == 1 ? ['/class/group_class/' + nextClass.id] : ['/class/single_class/' + nextClass.id]">
            {{ "access-to-class" | translate }}
          </button>
        </ng-template>
      </mat-card>
      <mat-card class="custom-dashboard-mat-card margin-top-1">
        <div class="mat-h3 font-weight-bold primary"><i class="fas fa-users"></i> {{ "your-groupal-class" | translate }}:</div>
        <div *ngIf="groupalListMine" class="row">
          <div *ngFor="let groupalClass of groupalListMine" class="col-md-5 border p-2 m-2">
            <div class="bold">{{ groupalClass.name }}</div>
            <div><i class="far fa-clock"></i> {{ groupalClass.date }} - {{ groupalClass.hour }}</div>
            <div><i class="fas fa-graduation-cap"></i> {{ groupalClass.teacher.fullName }}</div>
            <div><i class="fas fa-info-circle"></i> {{ "status" | translate }}:  <span [ngClass]="groupalClass.is_rejectable=='1' ? 'non-active-class-group-list' : 'active-class-group-list'">{{ groupalClass.state }}</span></div>
            <div *ngIf="groupalClass.is_rejectable=='1'" class="pt-3">
              <a 
              [routerLink]="[
              '/student/group-classes/class-detail/',
              groupalClass.id
            ]"
               
                class="btn btn-primary">{{ "accept" | translate }}
              </a>
                 | 
              <a class="btn btn-secondary" (click)="rejectGroupalInvitation(groupalClass.id)">{{ "reject" | translate }}

              </a></div>
            
          </div>
        </div>

      </mat-card>
    </div>

    <!-- Right -->
    <div class="col-md-4 margin-top-1">
      <!-- Test class -->
      <mat-card *ngIf="testClasses > 0">
        <div>
          {{ "test-classes-left" | translate: "{classes:" + testClasses + "}" }}
        </div>
        <div class="d-flex justify-content-center">
          <div class="margin-top-1">
            <button mat-raised-button class="gradient-button" [routerLink]="['/search/teacher']">
              {{ "ask-classes" | translate }}
            </button>
          </div>
        </div>
      </mat-card>

      <div class="d-flex flex-column content-buttons padding-left-2 padding-right-2 margin-top-2">
        <!-- <div class="margin-top-1">
          <button mat-raised-button color="primary" (click)="general.displayNotAvailableAction()">
            {{ "download-app" | translate }}
          </button>
        </div> -->

        <div class="margin-top-1">
          <h3>{{ "search-teacher-now" | translate }}</h3>
          <button mat-raised-button color="primary" [routerLink]="['/search/teacher']">
            <i class="fas fa-search"></i> {{ "search-teacher" | translate }}
          </button>
         
        </div>

        <div class="margin-top-1">
          <h3>{{ "search-groupal-interest" | translate }}</h3>
          <button mat-raised-button color="primary" [routerLink]="['/student/group-classes']">
            <i class="fas fa-users"></i> {{ "search-your-group-class" | translate }}
          </button>
          <p class="small">{{ "group-class-dashboard-info" | translate }} </p>
        
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-5 card p-3">
    <h2 class="pb-3 primary"><i class="fas fa-users"></i> {{ "group-class-dashboard-tittle-interest" | translate }} </h2>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">{{ "date" | translate }}</th>          
          <th scope="col">{{ "group-class-title" | translate }}</th>
          <th scope="col">{{ "language" | translate }}</th>        
          <th scope="col">{{ "duration" | translate }}</th>
          <th scope="col">{{ "available" | translate }}</th>
          <th>Precio</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="listedClasses==''">
          <td colspan="6" class="p-4 text-center">
            <p class="bold primary">{{ "no-groupal-available-for-you" | translate }}</p>
            <p>{{ "clic-button-search-groupal" | translate }}</p>
            <a class="btn btn-primary" routerLink="/student/group-classes">{{ "search-your-group-class" | translate }}</a></td>
        </tr>
        <tr *ngFor="let class of listedClasses">
          <td>{{ class.date | date:"dd-M-YYYY" }}<br><span class="small bold">{{ class.hour }} h.</span></td>
          
          <td>{{ class.name }}<br><span class="small">{{ class.lesson.name }} - {{ class.lesson_level.name }}</span></td>
          <td class="">{{ class.language.name }}</td>
        
          <td class="">{{ class.duration }} h.</td>
          <td class="text-center">{{ class.freePlaces }} </td>
          <td>{{ class.price | currency:"EUR" }} </td>
          <td>
            <i
                      class="far fa-eye"
                      alt="Ver más detalles"
                      title="Ver más detalles"
                      style="cursor: pointer"
                      [routerLink]="[
                        '/student/group-classes/class-detail/',
                        class.id
                      ]"
                    ></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row pt-3 border mt-5 pb-5">
    <div class="col-md-9">
      <h1 class="banner-blog-header"><i class="fas fa-cubes"></i> {{ "meet-our-blog" | translate }}</h1>
      <p class="pt-3">{{ "dashboard-blog-message" | translate }}</p>
    </div>
    <div class="col-md-3 text-center align-self-center">
      <a class="" href="https://wordiix.com/blog/" target="_blank"><button class="btn btn-primary">{{ "visit-our-blog" | translate }}</button></a>

    </div>
  </div>
</div>